<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="buttonDisabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>Händlerstorno</span>
        <b-modal
            v-model="modalState"
            id="modal-vendor-cancellation"
            title="Händlerstorno"
            @ok="submit()"
            cancel-title="abbrechen"
            size="md"
        ><!-- modal -->
            TODO message
        </b-modal>
    </b-button>
</template>
<script>
    // TODO https://coseon.jetbrains.space/p/synch/issues/60
    export default {
        props: ['customerOrder' ],
        data() {
            return {
                modalState: false,
                httpRequestInProgress: false
            }
        },
        computed: {
           buttonDisabled: function() { return this.httpRequestInProgress }
        },
        methods: {
            submit() {
                this.httpRequestInProgress = true;
                const payload = {};
                      
                Promise.all([
                    axios.post('/TODO', payload),
                    new Promise(r => setTimeout(r, 500))
                ]).then( (response) => {
                    this.httpRequestInProgress = false;
                
                }).catch( error => {
                    alert("Konnte Vorgang nicht ausfuehren.");
                    console.error(error);
                });
            }
        }
    }
</script>
